import { useEffect, useState } from "react";

// Aspectul interfeței: „fiord” (meniu jos, implicit la instalările noi), „navy” (cel existent, meniu lateral) sau „purple” (bară sus, sertar,
// plăci; fostul „portocaliu”). Alegerea Adminului (implicitul instalării) vine de la server; dacă Adminul permite, fiecare utilizator își poate
// alege propriul aspect (memorat în acest browser). Funcționalitățile nu depind de aspect: aceleași pagini, aceleași rute, aceleași apeluri.
// SUPERADMIN vede MEREU „navy” (decis de Sasha, 2026-11-02): nu urmează nici implicitul instalării, nici alegerea individuală.
export const THEMES = ["fiord", "navy", "purple"];
export const THEME_LABELS = { fiord: "Fiord (meniu jos)", navy: "Navy (clasic)", purple: "Purple (bară sus)" };
export const THEME_SHORT = { fiord: "Fiord", navy: "Navy", purple: "Purple" };
const LEGACY = { orange: "purple" };                   // valoarea veche „portocaliu” = „purple”
const norm = (v) => LEGACY[v] || v;
const PREVIEW_KEY = "onomad_ui_preview"; // previzualizare temporară (sesiunea acestui browser), peste orice altă alegere
const USER_KEY = "onomad_ui_user", DEFAULT_KEY = "onomad_ui_default", ALLOW_KEY = "onomad_ui_allow";

const read = (k) => { try { return localStorage.getItem(k); } catch { return null; } };
const write = (k, v) => { try { if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch { /* browser fără stocare: rămâne implicitul */ } };

let superadmin = false;   // setat de ThemeSync (App.js) cât timp utilizatorul curent e Superadmin
export function setSuperadmin(flag) { const f = !!flag; if (f !== superadmin) { superadmin = f; applyTheme(); } }

export const userMayChoose = () => !superadmin && read(ALLOW_KEY) === "1";
const readPreview = () => { try { return sessionStorage.getItem(PREVIEW_KEY); } catch { return null; } };
const writePreview = (v) => { try { if (v === null) sessionStorage.removeItem(PREVIEW_KEY); else sessionStorage.setItem(PREVIEW_KEY, v); } catch { /* fără stocare */ } };
export function installDefault() { const d = norm(read(DEFAULT_KEY)); return THEMES.includes(d) ? d : "fiord"; }
export function currentTheme() {
  if (superadmin) return "navy";
  const pv = norm(readPreview());
  if (THEMES.includes(pv)) return pv;
  const u = norm(read(USER_KEY));
  return userMayChoose() && THEMES.includes(u) ? u : installDefault();
}
export function applyTheme() {
  document.documentElement.dataset.ui = currentTheme();
  window.dispatchEvent(new Event("ui-theme-changed"));
}
export function setUserTheme(v) { writePreview(null); write(USER_KEY, THEMES.includes(v) ? v : null); applyTheme(); }
export function clearUserTheme() { write(USER_KEY, null); writePreview(null); applyTheme(); }
/** Previzualizare doar în acest browser (și când utilizatorii nu au voie să aleagă); dispare la salvare sau la închiderea filei. */
export function previewTheme(v) { writePreview(THEMES.includes(norm(v)) ? norm(v) : null); applyTheme(); }
/** Setările instalării (de la server): implicitul și dacă utilizatorii pot alege. */
export function setInstallSettings({ ui_theme, user_choice }) {
  write(DEFAULT_KEY, THEMES.includes(norm(ui_theme)) ? norm(ui_theme) : "fiord");
  write(ALLOW_KEY, user_choice === false ? "0" : "1");
  applyTheme();
}
export function useTheme() {
  const [t, setT] = useState(currentTheme);
  useEffect(() => {
    const on = () => setT(currentTheme());
    window.addEventListener("ui-theme-changed", on);
    return () => window.removeEventListener("ui-theme-changed", on);
  }, []);
  return t;
}
/** Aspectele cu pagină de start cu plăci, ⋮ pe rânduri și meniul grupat pe module (Fiord și Purple); Navy păstrează structura originală. */
export const isModernTheme = (t) => t === "fiord" || t === "purple";
